import React, { useState, useEffect, useContext } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Layout from 'components/sales/layout/layout';
import MomForm from 'components/brandActivation/momForm/momForm';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from '../../../../contexts/baseUrl/baseUrl';

const MinutesOfMeeting = ({
  meetingById = null,
  getMeetingById,
  createMom,
  match,
  history,
  imageUploadUrl,
  videoUploadUrl,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isFiled, setIsFiled] = useState(false);
  const [meetingId, setMeetingId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const inputs = {
    meetingDetails: null,
  };
  const [isModal, setIsModal] = useState(false);
  const [meetingData, setCorporateData] = useState(inputs);
  const handleForm = (val) => {
    setCorporateData({ ...meetingData, meetingDetails: val });
  };
  const handleSubmit = () => {
    const { meetingDetails } = meetingData;
    if (meetingDetails === null) {
      setIsFiled(true);
      setIsModal(false);
      return false;
    } else {
      setIsFiled(false);
      (async () => {
        setIsLoading(true);
        const res = await createMom(meetingDetails);
        setIsLoading(false);
        if (res) {
          setIsModal(true);
        }
      })();
    }
  };
  useEffect(() => {
    setMeetingId(match.params.id);
  }, [match.params.id]);

  const handleModalHide = () => {
    setIsModal(false);
    history.goBack();
  };

  useEffect(() => {
    (async () => {
      if (match.params.id) {
        setIsLoading(true);
        await getMeetingById(match.params.id);
        setIsLoading(false);
      }
    })();
  }, [getMeetingById, match.params.id]);

  useEffect(() => {
    if (meetingById?.meeting) {
      setDetails(meetingById.meeting);
    }
  }, [meetingById]);

  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        {localization.createMom}
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  return (
    <Layout
      title={localization.createMom}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/scheduled-meetings/${details?.site_id}`}
    >
      <MomForm
        handleValue={handleForm}
        meetingId={meetingId}
        details={details !== null && details}
        imageUploadUrl={imageUploadUrl}
        videoUploadUrl={videoUploadUrl}
      />
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.meetingSuccess}</h5>
          <Button onClick={handleModalHide} className="btn btn-primary mb-4">
            {localization.momCreatedSuccessfully}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>
    </Layout>
  );
};

MinutesOfMeeting.propTypes = {};

export default MinutesOfMeeting;
